exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gavel-circle{width:350px;height:175px;background:#3498db;border-top-left-radius:175px;border-top-right-radius:175px;overflow:hidden;display:flex;align-items:flex-end;padding-left:45px}.gavel-circle p{align-self:center;font-weight:bold;font-size:18px;margin-left:20px}@media(max-width: 1400px){.gavel-circle{width:300px;height:150px;border-top-left-radius:150px;border-top-right-radius:150px;padding-left:30px}.gavel-circle p{font-size:14px}}@media(max-width: 1200px){.gavel-circle{width:250px;height:125px;border-top-left-radius:125px;border-top-right-radius:125px;padding-left:30px}}.gavel-circle div{display:flex}", ""]);

// exports
